import React, { useState } from "react";
import styled from "styled-components";

import {
  Button,
  Form,
  RouterLink,
  TextInput,
  Toolbar,
} from "@examspark/common-ui";

const Text = styled.div`
  color: #333;
  font-size: 1.3rem;
  line-height: 1.5em;
`;
const RegistrationTitle = styled.h1`
  margin: 0 0 2rem;
  font-weight: normal;
  color: #333;
  text-align: center;
`;

const RegisterConfirmationCode = (props: { onBack?: () => void }) => {
  const [confirmationCode, setConfirmationCode] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isResendingCode, setIsResendingCode] = useState(false);

  const handleConfirmSignUp = async () => {
    try {
      setIsSaving(true);
      // if (!form.email?.length) throw new Error("Missing Email Address");
      // if (!form.password?.length) throw new Error("Missing Password");
      // if (!confirmationCode.length)
      //   throw new Error("Missing Confirmation Code");

      // await confirmSignUp(form.email, confirmationCode);
      // await handleAccountCreation();
      setIsSaving(false);
    } catch (error) {
      alert(error);
      setIsSaving(false);
    }
  };

  const handleResendCode = async () => {
    try {
      // if (!form.email) throw new Error("Missing email address");
      // setIsResendingCode(true);
      // await resendCode(form.email);
      // setIsResendingCode(false);
      // window.alert(
      //   "Your code has been resent. Check your email (and possibly the spam folder) for this code."
      // );
    } catch (error) {
      setIsResendingCode(false);
    }
  };

  return (
    <div>
      <RegistrationTitle>Enter Confirmation Code</RegistrationTitle>
      <Text style={{ margin: "2rem 0" }}>
        We just sent a confirmation code to your email address. Enter that code
        in the field below. Didn't receive it? Check your spam folder.
      </Text>
      <Form>
        <Form.FieldList>
          <Form.Field label="Confirmation Code">
            <TextInput
              maxLength={6}
              name="code"
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
            />
          </Form.Field>
          <Toolbar>
            <Button
              title="Confirm Registration"
              variant="contained"
              stretch
              color="primary"
              onClick={handleConfirmSignUp}
              isLoading={isSaving}
              disabled={confirmationCode.length !== 6 || isSaving}
            >
              Confirm Registration
            </Button>
          </Toolbar>
          <Toolbar>
            <Button
              isLoading={isResendingCode}
              title="Resend Code"
              variant="contained"
              stretch
              onClick={handleResendCode}
            >
              Resend Code
            </Button>
          </Toolbar>
          <RouterLink to="." onClick={props.onBack}>
            Return to Registration
          </RouterLink>
        </Form.FieldList>
      </Form>
    </div>
  );
};

export default RegisterConfirmationCode;
